module.exports = __webpack_public_path__ + "static/media/Wright-and-Eskaros-Pancreas.d14b132d.jpg";